import { matrixCheck } from './matrixCheck';
import { matrixCreateEmpty } from './matrixCreateEmpty';
export function matrixTranspose(matrix, options = {}) {
    matrixCheck(matrix);
    const { ArrayConstructor } = options;
    const nbRows = matrix.length;
    const nbColumns = matrix[0].length;
    // Create new matrix with swapped dimensions
    const result = matrixCreateEmpty({
        nbColumns: nbRows,
        nbRows: nbColumns,
        ArrayConstructor,
    });
    for (let i = 0; i < nbRows; i++) {
        for (let j = 0; j < nbColumns; j++) {
            result[j][i] = matrix[i][j];
        }
    }
    return result;
}
//# sourceMappingURL=matrixTranspose.js.map